export const SET_MODAL = 'SET_MODAL';
export const RESET_MODAL = 'RESET_MODAL';
